/*
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as person from './moudules/person'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as log from './moudules/log'
import * as privilege from './moudules/privilege'
import * as info from './moudules/info'
import * as infoType from './moudules/infoType'
import * as infoMenu from './moudules/infoMenu'
import * as attach from './moudules/attach'
import * as sysTaskType from './moudules/sysTaskType'
import * as sysTaskDeal from './moudules/sysTaskDeal'
import * as personCenter from './moudules/personCenter'
import * as sysParameter from './moudules/sysParameter'
import * as commonPage from './moudules/commonPage'
import * as deptExtend from './moudules/deptExtend'
import * as deptRemoveApply from './moudules/deptRemoveApply'
import * as deptExtendUpdateRecord from './moudules/deptExtendUpdateRecord'
import * as attachUpdateRecord from './moudules/attachUpdateRecord'
import * as payCost from './moudules/payCost'
import * as generate from './moudules/generate'
import * as rewardsPunishments from './moudules/rewardsPunishments.js'
import * as report from './moudules/report.js'
import * as dictionary from './moudules/dictionary.js'
import * as expert from './moudules/expert.js'
import * as project from './moudules/project.js'
import * as projectExpert from './moudules/projectExpert.js'
import * as hhb from './moudules/hhb'
import * as smsNotification from './moudules/smsNotification'
import * as hyzq from './moudules/hyzq'
import * as clty from './moudules/clty'
import * as bidder from './moudules/bidder'
import * as zyjn from './moudules/zyjn'
import * as mZyjnSkillLevel from './moudules/mZyjnSkillLevel'
import * as kwry from './moudules/kwry'
import * as cdgl from './moudules/cdgl'
import * as zlbak from './moudules/zlbak'
import * as pgdj from './moudules/pgdj'
import * as dwzs from './moudules/dwzs'

// 默认全部导出
export default {
  login,
  user,
  dept,
  role,
  menu,
  log,
  person,
  privilege,
  info,
  infoType,
  infoMenu,
  sysTaskType,
  sysTaskDeal,
  attach,
  personCenter,
  sysParameter,
  commonPage,
  deptExtend,
  deptRemoveApply,
  deptExtendUpdateRecord,
  attachUpdateRecord,
  payCost,
  generate,
  rewardsPunishments,
  report,
  dictionary,
  expert,
  project,
  projectExpert,
  hhb,
  hyzq,
  smsNotification,
  clty,
  bidder,
  zyjn,
  mZyjnSkillLevel,
  kwry,
  cdgl,
  zlbak,
  pgdj,
  dwzs
}



// WEBPACK FOOTER //
// ./src/http/api.js